import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Modal } from '@getro/rombo';

import MfaCodeInput from 'components/molecules/MfaCodeInput';

const MODAL_COPY = {
  disable: {
    title: 'Disable two-factor authentication',
    paragraphs: [
      'You will no longer be asked for the authentication code when you login.',
      'To disable it, enter the code from your authenticator app below:',
    ],
  },
  regenerate: {
    title: 'Regenerate backup codes',
    paragraphs: [
      'Your existing backup codes will stop working and a new set will be generated.',
      'To continue, enter the code from your authenticator app below:',
    ],
  },
};

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const BodyText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  font-size: 14px;
  line-height: 1.4;
  color: ${({ theme }) => theme.colors.text.main};

  p {
    margin: 0;
  }
`;

const CodeSection = styled.div`
  display: flex;
  justify-content: center;
`;

const MfaCodeModal = ({ variant, onSubmit, onCancel, dataCyPrefix }) => {
  const { title, paragraphs } = MODAL_COPY[variant];

  return (
    <Modal title={title} onCancel={onCancel}>
      <Content>
        <BodyText>
          {paragraphs.map((paragraph) => (
            <p key={paragraph}>{paragraph}</p>
          ))}
        </BodyText>
        <CodeSection>
          <MfaCodeInput onSubmit={onSubmit} dataCyPrefix={dataCyPrefix} formKey={`${dataCyPrefix}-${variant}`} />
        </CodeSection>
      </Content>
    </Modal>
  );
};

MfaCodeModal.propTypes = {
  variant: PropTypes.oneOf(['disable', 'regenerate']).isRequired,
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  dataCyPrefix: PropTypes.string.isRequired,
};

export default MfaCodeModal;
